const justifyClassMap = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const itemsClassMap = {
  top: 'items-start',
  center: 'items-center',
  bottom: 'items-end',
};

export type AlignX = 'left' | 'center' | 'right';
export type AlignY = 'top' | 'center' | 'bottom';

interface UseFlexAlignProps {
  align?: AlignX;
  alignY?: AlignY;
}

export function useFlexAlign({ align, alignY }: UseFlexAlignProps) {
  return {
    justifyClass: align ? justifyClassMap[align] : undefined,
    itemsClass: alignY ? itemsClassMap[alignY] : undefined,
  };
}

export function alignDirectionToCol(align: AlignX): AlignY {
  switch (align) {
    case 'left':
      return 'top';
    case 'center':
      return 'center';
    case 'right':
      return 'bottom';
  }
}

export function alignDirectionToRow(align: AlignY): AlignX {
  switch (align) {
    case 'top':
      return 'left';
    case 'center':
      return 'center';
    case 'bottom':
      return 'right';
  }
}
